// extracted by mini-css-extract-plugin
module.exports = {"filterButton":"az_YLc","filterLabel":"az_ZLc","slimFilterLabel":"az__Lc","slimFilterButton":"az_aMc"};